import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { EmissionsChartProps } from "./types";

export const EmissionsChart = ({ data }: EmissionsChartProps) => {
  const options: Highcharts.Options = {
    chart: { type: "spline" },
    title: { text: undefined },
    xAxis: { categories: data.years.map(String) },
    yAxis: { title: { text: "tCO₂e/yr" } },
    series: [
      {
        name: "Baseline",
        type: "spline",
        data: data.baseline,
        color: "#9E9E9E",
        dashStyle: "Dash",
      },
      {
        name: "Target",
        type: "spline",
        data: data.target,
        color: "#FF9800",
        dashStyle: "Dash",
      },
      {
        name: "Projected",
        type: "spline",
        data: data.withScenario,
        color: "#1976d2",
      },
    ],
    credits: { enabled: false },
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};
